import { IGroupOptions } from 'fabric/fabric-impl';

export const DRAGGABLE_DEFAULT_OPTIONS: IGroupOptions = {
  fill: 'transparent',
  hasControls: false,
  hasBorders: false,
  hoverCursor: 'grab',
  moveCursor: 'grabbing',
};